import { getConciliationAmountLimit } from '../../../../../../utils/conciliationAmountLimit'
import { memo, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import TablaBancoCreate from './TablaBancoCreate'
import GlobalContext from '../../../../../../../context/global-context'
import { OrganizationAPI } from '../../../../../../../api/organization.api'
import { BusinessAPI } from '../../../../../../../api/business.api'
import dayjs from 'dayjs'
import LoaderAdm from '../../../../../../../assets/svgIcons/LoaderAdm.json'
import Lottie from 'lottie-react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import clsx from 'clsx'
import FilterDateConciliar from '../../../../../table/FilterDateConciliar'
import { BankAPI } from '../../../../../../../api/bancos.api'
import { useInfiniteBankTransactions } from '../../../../../../../hooks/useInfiniteBankTransactions'
import TablaTraspasoCuenta from './TablaTraspasoCuenta'
import { useBanks } from '../useBanks.hook'
import TablaDocumento from './TablaDocumento'
import ModalDocumentos from './ModalDocumentos'
import { Button } from '../../../../../ui'
import Plantillas from '../../Vinculaciones/Plantillas'
import { LinkageCreationContext } from '../../Vinculaciones/LinkageCreationContext'
import { useBankLinkageCreation } from './useBankLinkageCreation'
import { loadCreatedLinkageRows } from './loadCreatedLinkageRows'
import { loadBankLinkageRows } from './loadBankLinkageRows'
import {
  getMovementDisplayAmount,
  isSameConciliationMovement,
  mergeDocumentConciliationLinkage,
  isBankConciliationMovement,
  isOppositeBankMovement,
  isVinculacionRow,
  isSiiDocument,
  mergeUniqueMovements
} from './respaldo.utils'

const mergeUnique = mergeUniqueMovements

const FiltrosLista = ({libroId, montoFilter,dataLinkage,setReloadData,onCurrentData,dataModal, onInitialSelectedIds, onCurrentSelectedIdsChange,setTipoPago,dataTraspaso,tipoPago,
  selectedCheckboxes,setSelectedCheckboxes,onCurrentRealIdsChange,setModalData,modalData,onCreationStatusChange,onCreationCompleted,onCreationError,onConciliateCreated}) => {

  const [value, setValue] = useState([null, null]) // inputs
  const [debouncedValue, setDebouncedValue] = useState([null, null]) // para filtro manual
  const [data, setData] = useState({})
  const [createdRows, setCreatedRows] = useState([])
  const [creationFormsHidden, setCreationFormsHidden] = useState(false)
  const { currentBusiness } = useContext(GlobalContext)
  const organizationAPI = new OrganizationAPI()
  const [filters] = useState({
    fechaInicio: dayjs().startOf('year').format('YYYY-MM-DD'),
    fechaFin: dayjs().format('YYYY-MM-DD')
  })
  const [rowsPerPage] = useState(-1)
  const [dataBanco, setDataBanco] = useState({})
  const [dataTraspasoCuenta, setDataTraspasoCuenta] = useState({})
  const [acounts] = useState([])
  const [currentAcount] = useState(acounts[0] || null)
  const bankAPI = new BankAPI()
  const [tempFilters, setTempFilters] = useState({ ...filters })
  const [dateQueryFilters, setDateQueryFilters] = useState({ ...filters })
  const [searchTerm, setSearchTerm] = useState('')
  const [valoresAprox, setValoresAprox] = useState(false)
  const [folioTerm] = useState('')
  const [selectedFilters, setSelectedFilters] = useState([])
  const [isLoadingData, setIsLoadingData] = useState(true)
  const [isLoadingTraspaso, setIsLoadingTraspaso] = useState(true)
  const [page] = useState(0)
  const [porcentajeRange] = useState([0, 100])
  const [showFilters, setShowFilters] = useState(true)
  const [selectedOptions, setSelectedOptions] = useState(['todas', 'clientes', 'bancos', 'traspaso'])
  const selectedRowsByOptionRef = useRef({})
  const selectedIdsByOptionRef = useRef({})
  const selectedRealIdsByOptionRef = useRef({})

  const [openSection, setOpenSection] = useState(null)
  const [collapsedSections, setCollapsedSections] = useState({})
  const [showModalCaja, setShowModalCaja] = useState(false);
  const [extraRowData] = useState(null);
  const [order, setOrder] = useState({
    col: '',
    field: '',
    direction: 'asc'
  })
  const creation = useBankLinkageCreation({
    bankMovementType: dataModal?.categoriaTipoMovimiento ?? dataModal?.tipoMovimiento ??
      ({ 6: 'abono', 7: 'cargo' }[Number(dataModal?.origenTabla)]),
    onStart: () => {
      setCreationFormsHidden(true)
      setSelectedFilters(['vinculaciones'])
      setSelectedOptions(['clientes'])
      setOpenSection('clientes')
      setValoresAprox(false)
    },
    onStatusChange: onCreationStatusChange,
    onCompleted: onCreationCompleted,
    onError: message => {
      if (message) setCreationFormsHidden(true)
      onCreationError?.(message)
    },
    loadRows: (payload, requestOptions) => loadCreatedLinkageRows({
      api: organizationAPI,
      businessApi: new BusinessAPI(),
      businessId: currentBusiness.id,
      libroId,
      from: dateQueryFilters.fechaInicio,
      to: dateQueryFilters.fechaFin,
      payload,
      montoTotal: dataModal?.montoTotal,
      requestOptions
    }),
    onCreated: async (rows, refreshedRows) => {
      setData(refreshedRows.filter(row => row._creationSource !== 'vinculaciones' ||
        rows.some(created => isSameConciliationMovement(row, created))))
      setCreatedRows(prev => mergeUnique([...rows, ...prev]))
      setSelectedCheckboxes(prev => ({
        ...prev,
        ...Object.fromEntries(rows.map(row => [row.id ?? row.idPrincipal, true]))
      }))
      const previous = selectedRowsByOptionRef.current.clientes || []
      selectedRowsByOptionRef.current.clientes = mergeUnique([...previous, ...rows])
      const allRows = mergeUnique([
        ...Object.values(selectedRowsByOptionRef.current).flat(),
        ...(Array.isArray(dataModal?.linkage) ? dataModal.linkage : [])
      ])
        .filter(row => rows.some(created => isSameConciliationMovement(row, created)) ||
          selectedCheckboxes[row.id ?? row.idPrincipal] !== false)
      selectedIdsByOptionRef.current.clientes = selectedRowsByOptionRef.current.clientes
        .map(row => row.id ?? row.idPrincipal)
      selectedRealIdsByOptionRef.current.clientes = selectedRowsByOptionRef.current.clientes
        .map(row => row.idPrincipal ?? row.id)
      onCurrentData(allRows)
      onCurrentSelectedIdsChange(allRows.map(row => row.id ?? row.idPrincipal))
      onCurrentRealIdsChange(allRows.map(row => row.idPrincipal ?? row.id))
      setSelectedOptions(prev => [...new Set([...prev.filter(option => option !== 'todas'), 'clientes'])])
      setOpenSection('clientes')
      setSelectedFilters(['vinculaciones'])
      setSearchTerm('')
      await onConciliateCreated(allRows)
      setValoresAprox(false)
    }
  })

  const bankBridge = useBanks(s => s.bankBridge) || {}
  const resetBankBridge = useBanks(s => s.resetBankBridge)
  const showBridge = useMemo(() => {
    return bankBridge?.isFirstForBusiness &&
      (bankBridge?.state === 'starting' || bankBridge?.state === 'running')
  }, [bankBridge?.isFirstForBusiness, bankBridge?.state])

  useEffect(() => {
    if (!showBridge && !transactions.length) {
      refetch(true)
    }
  }, [showBridge])

  const isCollapsed = key => selectedOptions.includes('todas')
    ? Boolean(collapsedSections[key])
    : openSection !== key;
  const toggleSection = key => {
    if (selectedOptions.includes('todas')) {
      setCollapsedSections(prev => ({ ...prev, [key]: !prev[key] }))
      return
    }
    setOpenSection(prev => (prev === key ? null : key));
  };

const handleCheckboxChange = key => {
  const exists = selectedOptions.includes(key)

  const updated = exists
    ? selectedOptions.filter(k => k !== key)
    : [...selectedOptions, key]

  setSelectedOptions(updated)

  if (!exists) {
    setOpenSection(key)

    if (key === 'caja') {
      setShowModalCaja(true)
    }
  }
}

  const handleCurrentDataForOption = option => rows => {
    const previousRows = selectedRowsByOptionRef.current[option] || []
    const visibleRows = Array.isArray(rows) ? rows : []
    const rowsForOption = mergeUnique([...previousRows, ...visibleRows]).filter(item => {
      const id = item?.id ?? item?.idPrincipal ?? item?.customId
      return selectedCheckboxes[id] !== false
    })
    const next = {
      ...selectedRowsByOptionRef.current,
      [option]: rowsForOption
    }
    selectedRowsByOptionRef.current = next
    const allSelectedRows = mergeUnique(Object.values(next).flat())
    onCurrentData(allSelectedRows)
    onCurrentSelectedIdsChange(
      allSelectedRows
        .map(item => item?.id ?? item?.idPrincipal ?? item?.customId)
        .filter(id => id != null)
    )
    onCurrentRealIdsChange(
      allSelectedRows
        .map(item => item?.idPrincipal ?? item?.id)
        .filter(id => id != null && Number.isFinite(Number(id)))
    )
  }

  const handleCajaCurrentData = useCallback(rows => {
    const next = {
      ...selectedRowsByOptionRef.current,
      caja: Array.isArray(rows) ? rows : []
    }
    selectedRowsByOptionRef.current = next
    onCurrentData(mergeUnique(Object.values(next).flat()))
  }, [onCurrentData])

  const handleSelectedIdsForOption = option => ids => {
    const next = {
      ...selectedIdsByOptionRef.current,
      [option]: Array.isArray(ids) ? ids : []
    }
    selectedIdsByOptionRef.current = next
    onCurrentSelectedIdsChange([...new Set(Object.values(next).flat())])
  }

  const handleRealIdsForOption = option => ids => {
    const next = {
      ...selectedRealIdsByOptionRef.current,
      [option]: Array.isArray(ids) ? ids : []
    }
    selectedRealIdsByOptionRef.current = next
    onCurrentRealIdsChange([...new Set(Object.values(next).flat())])
  }

  const functionGetData = async () => {
    try {
      const rows = await loadBankLinkageRows({
        api: organizationAPI,
        businessId: currentBusiness.id,
        libroId,
        from: dateQueryFilters.fechaInicio,
        to: dateQueryFilters.fechaFin,
        montoTotal: dataModal?.montoTotal
      })
      setData(rows)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoadingData(false)
    }
  }

  const getBanco = async () => {
    try {
      const responseBank = await bankAPI.getListBank(currentBusiness.id) 
      setDataBanco(responseBank.data)
    } catch (error) {
      console.error(error)
    }
  }

  const getTraspasoEntreCuenta = async () => {
    try {
      setIsLoadingTraspaso(true)
      const response = await bankAPI.getTraspasoCuenta(currentBusiness?.id, libroId)
      setDataTraspasoCuenta(response.data)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoadingTraspaso(false)
    }
  }

  useEffect(() => {
    getBanco()
    getTraspasoEntreCuenta()
  }, [currentBusiness])

  const {
    data: infiniteData,
    refetch,
    fetchNextPage: fetchNextBankTransactions,
    hasNextPage: hasNextBankTransactions,
    isFetchingNextPage: isFetchingNextBankTransactions,
    isLoading: isLoadingBankTransactions
  } = useInfiniteBankTransactions({
    businessId: currentBusiness?.id || 0,
    productId: currentAcount?.id || 0,
    year: dayjs(dateQueryFilters.fechaInicio).format('YYYY'),
    month: 0,
    limit: 50,
    filters: {
      from: dateQueryFilters.fechaInicio,
      to: dateQueryFilters.fechaFin
    }
  })

  const transactions = useMemo(() => {
    return infiniteData?.pages?.flatMap(page => page.data) || []
  }, [infiniteData])

  const bankTransactions = useMemo(() => {
    const linkedIds = new Set(
      (Array.isArray(dataModal?.linkage) ? dataModal.linkage : [])
        .flatMap(linkage => [linkage?.id, linkage?.idPrincipal])
        .filter(id => id != null)
        .map(String)
    )
    const targetAmount = Math.abs(Number(dataModal?.montoTotal) || 0)

    const linkedBankRows = (Array.isArray(dataModal?.linkage) ? dataModal.linkage : [])
      .filter(isBankConciliationMovement)

    return mergeUnique([...linkedBankRows, ...transactions])
      .filter(transaction => Number(transaction?.auxiliar) !== 0)
      .filter(transaction => isOppositeBankMovement(transaction, dataModal))
      .filter(transaction =>
        transaction?.nombreCuentaBanco?.trim().toLowerCase() !== 'caja principal'
      )
      .map(transaction => {
        const transactionId = transaction?.idPrincipal ?? transaction?.id
        const amount = Math.abs(Number(transaction?.montoAbono || transaction?.montoCargo) || 0)

        return {
          ...transaction,
          id: transaction.id ?? transaction.idPrincipal,
          seleccionado: linkedIds.has(String(transactionId)),
          diferenciaMonto: Math.abs(amount - targetAmount)
        }
      })
      .sort((a, b) => {
        if (a.seleccionado !== b.seleccionado) return a.seleccionado ? -1 : 1
        return valoresAprox ? a.diferenciaMonto - b.diferenciaMonto : 0
      })
  }, [transactions, dataModal, valoresAprox])

  const bankTransactionsCount = infiniteData?.pages?.[0]?.count ?? bankTransactions.length

   useEffect(() => {
      if (bankBridge?.state === 'done') {
        if (typeof resetBankBridge === 'function') resetBankBridge()
      }
    }, [bankBridge?.state])

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, 500) // Espera 500ms después del último movimiento

    return () => {
      clearTimeout(handler)
    }
  }, [value])

  useEffect(() => {
    const handler = setTimeout(() => setDateQueryFilters(tempFilters), 400)
    return () => clearTimeout(handler)
  }, [tempFilters])

  const resetSlider = () => {
    const defaultValue = [1, getConciliationAmountLimit(dataModal?.montoTotal)]
    setValue(defaultValue)
    setDebouncedValue(defaultValue)
  }

  useEffect(() => {
    if (!creation.isProcessing && (selectedOptions.includes('clientes') || selectedOptions.includes('caja'))) {
      functionGetData()
    }
  }, [debouncedValue, dataModal?.montoTotal, dateQueryFilters, selectedOptions])

  const handleDateChange = (key, newValue) => {
    const newDate = dayjs(newValue)
    setTempFilters(prev => ({
      ...prev,
      [key]: newDate.format('YYYY-MM-DD')
    }))

  }

  const getTipoRespaldoOptions = () => {
    const baseOptions = [
      { label: "Todos", value: "todas" },
      { label: "Documentos SII", value: "clientes" },
      { label: "Bancos", value: "bancos" },
      { label: "Traspaso entre cuentas", value: "traspaso", disabled: isDisabled }
    ]

    if (dataModal?.categoriaTipoMovimiento === "abono") {
      return [
        ...baseOptions,
        { label: "Vinculaciones", value: "vinculaciones" }
      ]
    }

    if (dataModal?.categoriaTipoMovimiento === "cargo") {
      return [
        ...baseOptions,
        { label: "Boleta de honorarios", value: "boletaDeHonorarios" },
        { label: "Vinculaciones", value: "vinculaciones" },
        { label: "Formulario 29 (F29)", value: "f29" },
        { label: "Previred", value: "previred" },
        { label: "Remuneración", value: "remuneracion" }
      ]
    }

    return baseOptions
  }
  /* const filtrosSoloConFacturas = new Set([
      "previred",
      "remuneracion",
      "documentosPorCompra",
      "boletaDeHonorarios"
    ])*/

   const handleTipoRespaldoChange = (value) => {
    if (value === "todas") {
      setCollapsedSections({})
      setSelectedOptions(['todas', 'clientes', 'bancos', ...(isDisabled ? [] : ['traspaso'])])
      setSelectedFilters([])
      setOpenSection(null) // o lo que represente "todo abierto"
      return
    }

    const sectionKeys = ["clientes", "bancos", "traspaso"]

    if (sectionKeys.includes(value)) {
      setSelectedOptions([value])
      setSelectedFilters([])
      setOpenSection(value)
      return
    }

    // filtros internos (boleta, previred, etc.)
    setSelectedOptions(['clientes'])
    setSelectedFilters([value])
    setOpenSection("clientes")
  }

   const handleOpenCaja = () => {
    setSelectedOptions(prev => [...new Set([...prev.filter(option => option !== 'todas'), 'caja'])])
    setSelectedFilters([])
    setOpenSection("caja")
    setShowModalCaja(true)
   } 

  const linkageRows = Array.isArray(dataModal?.linkage) ? dataModal.linkage : []
  const isLinkedRow = item =>
    linkageRows.some(linkage => isSameConciliationMovement(item, linkage))

  const filteredData = useMemo(() => {
    if (!Array.isArray(data)) return []
    const total = Math.abs(dataModal?.montoTotal)
    const getRowAmount = getMovementDisplayAmount
    const calcPorcentaje = (monto, total) => {
      const diff = Math.abs(monto - total)
      const pct = (1 - diff / total) * 100
      return Math.max(pct, 0)
    }

    const filtroOrigenMap = {
      documentosPorAprobar: 2,
      documentosPorCompra: 8,
      boletaDeHonorarios: [4, 11],
      f29: 39,
      previred: 30, 
      remuneracion: 29 
    }

    const origenesSeleccionados = selectedFilters
      .flatMap(filtro => filtroOrigenMap[filtro] ?? [])

    const sourceRows = mergeDocumentConciliationLinkage(mergeUnique([...createdRows, ...data]), linkageRows)
    const onlySii = selectedOptions.includes('clientes') &&
      !selectedOptions.includes('todas') && selectedFilters.length === 0

    const aplicarMontoYFecha = dataModal?.status === 'PENDIENTE'

    const exactMatches = valoresAprox
      ? mergeUnique(sourceRows).filter(item => getRowAmount(item) === Number(dataModal?.montoTotal))
      : []

    let rangoMatches = []
    if (valoresAprox && exactMatches.length === 0 && aplicarMontoYFecha) {
      rangoMatches = mergeUnique(sourceRows).filter(
        item =>
          (debouncedValue?.[0] ?? 0) <= getRowAmount(item) &&
          getRowAmount(item) <= (debouncedValue?.[1] ?? Infinity)
      )
    }

    let dataConPrioridad = []
    if (exactMatches.length > 0) {
      const sinDuplicados = sourceRows.filter(item => !exactMatches.includes(item))
      dataConPrioridad = [...exactMatches, ...sinDuplicados]
    } else if (rangoMatches.length > 0) {
      const sinDuplicados = sourceRows.filter(item => !rangoMatches.includes(item))
      dataConPrioridad = [...rangoMatches, ...sinDuplicados]
    } else {
      dataConPrioridad = mergeUnique(sourceRows)
    }

    // Filtros comunes
    let baseFiltered = dataConPrioridad.filter(item => {
      const matchPalabraClave =
        searchTerm === '' ||
        (item.razonSocial && item.razonSocial.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.nombreCuenta && item.nombreCuenta.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.nombreFolio && item.nombreFolio.toLowerCase().includes(searchTerm.toLowerCase()))

      const matchFolio =
        folioTerm === '' ||
        (item.folio && item.folio.toLowerCase().includes(folioTerm.toLowerCase()))

      // Las vinculaciones pueden informar el origen en `nombreOrigen`, `origen`
      // o solamente mediante los campos propios de una plantilla manual.
      const matchVinculaciones =
        !selectedFilters.includes('vinculaciones') || isVinculacionRow(item)

      const matchFiltro =
        origenesSeleccionados.length === 0 || origenesSeleccionados.includes(Number(item.origenTabla))

      return matchPalabraClave && matchFolio && matchFiltro && matchVinculaciones &&
        (!onlySii || isSiiDocument(item))
    })

    if (linkageRows.length > 0) {
      const vinculados = baseFiltered.filter(isLinkedRow)
      baseFiltered = [...vinculados, ...baseFiltered.filter(item => !isLinkedRow(item))]
    }

    let filasConPorcentaje = baseFiltered
      .map(item => ({
        ...item,
        seleccionado: item.seleccionado === true || isLinkedRow(item),
        porcentaje: calcPorcentaje(getRowAmount(item), total)
      }))
      .filter(
        item => item.porcentaje >= porcentajeRange[0] && item.porcentaje <= porcentajeRange[1]
      )

    if (valoresAprox) {
      filasConPorcentaje = filasConPorcentaje.sort((a, b) => b.porcentaje - a.porcentaje)
    }

    if ((dataModal?.status === 'PARCIALMENTE CONCILIADO' || dataModal?.status === 'CONCILIADO') && Array.isArray(dataModal.linkage)) {
      const datosLinkeados = filasConPorcentaje.filter(isLinkedRow)
      const datosNoLinkeados = filasConPorcentaje.filter(item => !isLinkedRow(item))

      filasConPorcentaje = [...datosLinkeados, ...datosNoLinkeados]
    }

    filasConPorcentaje = filasConPorcentaje.sort((a, b) => {
      const aLinked = isLinkedRow(a)
      const bLinked = isLinkedRow(b)
      if (aLinked !== bLinked) return aLinked ? -1 : 1
      const aConciliado = a.estado === 'CONCILIADO' || a.estado === 'PARCIALMENTE CONCILIADO'
      const bConciliado = b.estado === 'CONCILIADO' || b.estado === 'PARCIALMENTE CONCILIADO'

      if (aConciliado && !bConciliado) return -1
      if (!aConciliado && bConciliado) return 1
      return 0
    })

    return mergeUnique(filasConPorcentaje)
  }, [data, searchTerm, folioTerm, selectedFilters, selectedOptions, dataModal, debouncedValue, porcentajeRange, valoresAprox, createdRows])

  const handleSort = ({ col, field }) => {
    const isAsc = order.col === col && order.direction === 'asc'
    setOrder({ col, field, direction: isAsc ? 'desc' : 'asc' })
  }

  const sortedData = useMemo(() => {
    if (!order.field) return filteredData

    const getSortValue = row => {
      switch (order.field) {
        case 'documento':
          return `${row?.nombreFolio || ''} ${row?.numeroFolio || ''}`
        case 'cliente':
          return row?.razonSocial || row?.glosa || row?.descripcion || ''
        case 'fecha': {
          if (!row?.fecha) return null
          const timestamp = dayjs(row?.fecha).valueOf()
          return Number.isNaN(timestamp) ? null : timestamp
        }
        case 'clasificacion':
          return `${row?.nombreCuenta || ''} ${row?.codigoCuenta || ''}`
        case 'monto':
          return getMovementDisplayAmount(row)
        case 'saldoAsignar':
          return Number(row?.monto ?? 0)
        case 'status':
          return String(row?.status || '').replace(/\s*undefined\s*/gi, '').trim()
        case 'acciones':
          return selectedCheckboxes?.[row?.id] ? 1 : 0
        default:
          return row?.[order.field] ?? ''
      }
    }

    const direction = order.direction === 'desc' ? -1 : 1

    return filteredData
      .map((row, index) => ({ row, index }))
      .sort((a, b) => {
        const aLinked = isLinkedRow(a.row)
        const bLinked = isLinkedRow(b.row)
        if (aLinked !== bLinked) return aLinked ? -1 : 1
        const valueA = getSortValue(a.row)
        const valueB = getSortValue(b.row)

        if (valueA == null && valueB == null) return a.index - b.index
        if (valueA == null) return 1
        if (valueB == null) return -1

        const comparison =
          typeof valueA === 'number' && typeof valueB === 'number'
            ? valueA - valueB
            : String(valueA).localeCompare(String(valueB), 'es', {
                numeric: true,
                sensitivity: 'base'
              })

        return comparison === 0 ? a.index - b.index : comparison * direction
      })
      .map(({ row }) => row)
  }, [filteredData, order, selectedCheckboxes])

  const paginatedData =
    rowsPerPage > 0
      ? sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      : sortedData

  const renderSection = (key, title, content) => (
    <div
      key={`sec-${key}`}
      className="border border-gray-200 rounded-3xl bg-gray-100 mt-3 font-medium"
    >
      <button
        type="button"
        onClick={() => toggleSection(key)}
        className="w-full flex items-center justify-between px-3 py-2"
        aria-expanded={!isCollapsed(key)}
        aria-controls={`sec-panel-${key}`}
      >
        <span className="text-sm font-medium">{title}</span>
        <KeyboardArrowDownIcon
          className={clsx('transition-transform', {
            'rotate-180': !isCollapsed(key)
          })}
        />
      </button>

      <div
        id={`sec-panel-${key}`}
        className={clsx(
          'transition-[max-height] duration-300 ease-in-out overflow-hidden',
          isCollapsed(key) ? 'max-h-0' : 'flex-1 h-full'
        )}
      >
        <div className="p-2 pt-0">{isCollapsed(key) ? null : content}</div>
      </div>
    </div>
  )

  // Siempre convertir en array seguro
  const bancos = Array.isArray(dataBanco) ? dataBanco : [];

  // Filtramos bancos válidos
  const bancosValidos = bancos.filter(
    b => b.bank?.name !== "Caja Principal"
  );

  // Condición final del checkbox
  const hasMultipleBanks = bancosValidos.length > 1;
  const isParcialmenteConciliado = dataModal?.status === 'PARCIALMENTE CONCILIADO';
  const isDisabled = !hasMultipleBanks || isParcialmenteConciliado;


const selectValue =
  openSection === "caja"
    ? selectedFilters[0] || "clientes"
    : selectedFilters[0] || openSection || selectedOptions[0] || "clientes"
  const bankMovementType = String(
    dataModal?.categoriaTipoMovimiento ?? dataModal?.tipoMovimiento ?? ''
  )
    .trim()
    .toLowerCase()
  const isCargoMovement = bankMovementType === 'cargo' || Number(dataModal?.origenTabla) === 7
  const isAbonoMovement = bankMovementType === 'abono' || Number(dataModal?.origenTabla) === 6
  const isActiveSectionLoading =
    openSection === 'bancos'
      ? isLoadingBankTransactions
      : openSection === 'traspaso'
        ? isLoadingTraspaso
        : isLoadingData
  return (
    <div className="h-full p-3 bg-white rounded-3xl shadow-md flex flex-col overflow-hidden">
     {isActiveSectionLoading ? (
        <div className='flex items-center justify-center h-64'>
          <Lottie animationData={LoaderAdm} loop style={{ width: 200, height: 200 }} />
        </div>
      ) : (
        <>
       <div className='border border-gray-200 rounded-3xl p-4 bg-gray-50'>
          <div className='flex flex-wrap gap-x-2 gap-y-4 items-start'>
            <div className='flex flex-wrap gap-x-2 gap-y-4 items-start flex-1'>
              <div className='min-w-[120px] flex flex-col justify-end mt-4 font-sans font-medium'>
            <FilterDateConciliar
              label='Fecha Desde'
              value={tempFilters.fechaInicio}
              onChange={newValue => handleDateChange('fechaInicio', newValue)}
            />
          </div>
          <div className='min-w-[120px] flex flex-col justify-end mt-4 font-sans font-medium'>
            <FilterDateConciliar
              label='Fecha Hasta'
              value={tempFilters.fechaFin}
              onChange={newValue => handleDateChange('fechaFin', newValue)}
            />
          </div>
          <div className='min-w-[120px]'>
            <label className='block mb-[1px] text-[11px] font-sans font-medium text-gray-700 mb-1 leading-tight'>
              Buscar
            </label>
            <input
              type='text'
              placeholder='Razón Social'
              onChange={e => setSearchTerm(e.target.value)}
              className='w-full h-8 text-xs px-4 rounded-full border border-gray-300 font-sans font-medium'
            />
          </div>
           <div className='flex items-end gap-2'>
             <div className='min-w-[220px] font-sans font-medium'>
              <label className='block mb-[1px] text-[11px] text-gray-700 leading-tight'>
                Tipo de Respaldo
              </label>

              <select
                className='w-full h-8 text-xs px-4 rounded-full border border-gray-300 font-sans'
                value={selectValue}
                onChange={(e) => handleTipoRespaldoChange(e.target.value)}
              >
                {getTipoRespaldoOptions().map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    disabled={option.disabled}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div className='min-w-[120px]'>
               <label className='mb-0.5 inline-flex h-8 cursor-pointer items-center gap-2 text-[11px] font-sans font-medium'>
               <input
                 type='checkbox'
                 checked={valoresAprox}
                 onChange={e => setValoresAprox(e.target.checked)}
                 className='rounded'
               />
               Monto Similares
             </label>
            </div>
              {(isCargoMovement || isAbonoMovement) && (
                <LinkageCreationContext.Provider value={{
                  runCreation: creation.runCreation,
                  bankAmount: Math.abs(Number(dataModal?.montoTotal ?? 0))
                }}>
                  <Plantillas
                    hideCreationModals={creationFormsHidden}
                    tipoMovimientoBanco={isAbonoMovement ? 'abono' : 'cargo'}
                    setSwitchGetData={() => {}}
                  />
                </LinkageCreationContext.Provider>
              )}
              {(isCargoMovement || isAbonoMovement) && <Button
                type="button"
                title={
                  isAbonoMovement
                    ? 'Cobro documento año anterior'
                    : 'Pago documento año anterior'
                }
                onClick={handleOpenCaja}
                className={clsx(
                  "h-8 px-4 rounded-full font-sans font-medium border text-[10px]",
                  selectedOptions[0] === "caja"
                    ? "bg-accent2 text-white"
                    : "border-gray-300 bg-accent2 text-white"
                )}
              />}
              </div>
          </div>
          <div className='ml-auto mt-5'>
            <button
              type='button'
              className='flex items-center px-1 py-0.5 bg-gray-200 rounded hover:bg-gray-300 transition'
              onClick={() => setShowFilters(prev => !prev)}
              aria-expanded={showFilters}
              aria-controls='filters-panel'
            >
              <KeyboardArrowDownIcon
                className={clsx('transition-transform', { 'rotate-180': showFilters })}
              />
            </button>
          </div>
        </div>
      </div>
      <div className='flex-1 min-h-0 mt-2 overflow-y-auto overflow-x-hidden font-sans font-medium'>
        <div className='flex flex-col space-y-2 mb-2'>

       {selectedOptions.includes('caja') &&
        renderSection(
          'caja',
          'Documento Referencia Año Anterior',
          <TablaDocumento
            rows={filteredData}
            dataModal={dataModal}
            tipoPago={tipoPago}
            onCurrentData={handleCajaCurrentData}
            selectedCheckboxes={selectedCheckboxes}
            setSelectedCheckboxes={setSelectedCheckboxes}
            modalData={modalData}
            setModalData={setModalData}
            setShowModalCaja={setShowModalCaja}
            extraRowData={extraRowData}
          />
          /*<p className='text-gray-700 text-center text-xs'>Información por añadir</p>*/
        )}
        {showModalCaja && (
          <ModalDocumentos
            open={showModalCaja}
            onClose={() => setShowModalCaja(false)}
            modalData={modalData}
            setModalData={setModalData}
            showObligationTypes={isCargoMovement}
          />
        )}
        {selectedOptions.includes('clientes') &&
          renderSection(
            'clientes',
            'Movimientos Cliente/Proveedor',
            <TablaBancoCreate
              onCheckboxChange={handleCheckboxChange}
              rows={paginatedData}
              libroId={libroId}
              montoFiltro={montoFilter}
              dataLinkage={dataLinkage}
              setReloadData={setReloadData}
              resetSlider={resetSlider}
              onInitialSelectedIds={onInitialSelectedIds}
              onCurrentSelectedIdsChange={handleSelectedIdsForOption('clientes')}
              onSort={handleSort}
              order={order}
              dataModal={dataModal}
              onCurrentData={handleCurrentDataForOption('clientes')}
              selectedCheckboxes={selectedCheckboxes}
              setSelectedCheckboxes={setSelectedCheckboxes}
              onCurrentRealIdsChange={handleRealIdsForOption('clientes')}
            />
          )}

          {selectedOptions.includes('traspaso') && (!selectedOptions.includes('todas') || !isDisabled) &&
            renderSection(
              'traspaso',
              'Traspaso entre cuentas',
              <>
              <TablaTraspasoCuenta
                rows={dataTraspasoCuenta}
                dataModal={dataModal}
                onCheckboxChange={handleCheckboxChange}
                onInitialSelectedIds={onInitialSelectedIds}
                onCurrentSelectedIdsChange={handleSelectedIdsForOption('traspaso')}
                onCurrentData={handleCurrentDataForOption('traspaso')}
                selectedCheckboxes={selectedCheckboxes}
                setSelectedCheckboxes={setSelectedCheckboxes}
                onCurrentRealIdsChange={handleRealIdsForOption('traspaso')}
              />
          </>
          )}

          {selectedOptions.includes('bancos') &&
            renderSection(
              'bancos',
              'Movimientos Bancarios',
              <TablaTraspasoCuenta
                rows={bankTransactions}
                dataModal={dataModal}
                excludeCurrentBank={false}
                selectReconciledByDefault={false}
                enablePagination
                hasMore={hasNextBankTransactions}
                isLoadingMore={isFetchingNextBankTransactions}
                onLoadMore={fetchNextBankTransactions}
                totalCount={bankTransactionsCount}
                onCheckboxChange={handleCheckboxChange}
                onInitialSelectedIds={onInitialSelectedIds}
                onCurrentSelectedIdsChange={handleSelectedIdsForOption('bancos')}
                onCurrentData={handleCurrentDataForOption('bancos')}
                selectedCheckboxes={selectedCheckboxes}
                setSelectedCheckboxes={setSelectedCheckboxes}
                onCurrentRealIdsChange={handleRealIdsForOption('bancos')}
              />
            )}
        </div>
        </div>
      </>
      )}
    </div>
  )
}

export default memo(FiltrosLista)
